

export default {
  wujiDashboardUser: 'https://report.bugly.tds.qq.com/page/dashboard',
  wujiDashboardProject: 'https://report.bugly.tds.qq.com/page/dashboard',
  releaseVersionDoc: 'https://bugly.tds.tencent.com/docs/tutorial/others/openapi/#docusaurus_skipToContent_fallback',
};
